<template>
  <div class="main-center-bottom">
    <div class="msg-character-count d-flex justify-space-between">
      <div class="subtitle-2">
        {{ messageScheduledId ? "Edit Scheduled Message" : "New Message" }}
      </div>
      <div class="msg-counter">Count: {{ messageValue.trim().length }}</div>
    </div>
    <div class="msg-input">
      <v-card outlined width="100%">
        <v-textarea
          ref="inputNewMessage"
          id="inputNewMessage"
          name="inputNewMessage"
          auto-grow
          class="input-textarea-container"
          :placeholder="inputPlaceholder"
          autofocus
          full-width
          solo
          flat
          v-model="messageValue"
        >
        </v-textarea>
        <!-- <v-toolbar dense flat> -->
        <div
          class="history-actions mt-4"
        >  
          <v-btn v-if="messageScheduledId" text bottom small @click="onDelete" class="mb-4"
            >Delete</v-btn
          >

          <v-menu
            open-on-hover
            top
            offset-y
            v-if="currentCustomer && !messageScheduledId"
            width="300"
            max-width="600"
          >
            <template v-slot:activator="{ on }">
              <v-btn small text color="secondary" class="mr-2 mb-4" v-on="on">
                <!-- <v-icon left>mdi-text-box-multiple-outline</v-icon> -->
                Template
              </v-btn>
            </template>
            <v-card>
              <v-card-title>Message Templates</v-card-title>
              <v-card-subtitle
                >Be sure to personalize before sending</v-card-subtitle
              >
              <v-divider></v-divider>
              <v-list>
                <v-list-item
                  v-for="(item, index) in messageTemplates"
                  :key="index"
                  three-line
                  class="messageTemplateItem"
                  @click="onSelectTemplate({ templateText: item.value })"
                >
                  <v-list-item-content>
                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                    <v-list-item-subtitle>{{
                      item.value
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-menu>
          <!-- <v-spacer></v-spacer> -->

          <v-btn text bottom small @click="onCancel" class="mb-4">Cancel</v-btn>

          <template>
            <v-dialog v-model="showDatePicker" width="320">
              <template v-slot:activator="{ attrs }">
                <v-btn
                  class="message-send-btn mr-2 mb-4"
                  id="messageSubmitBtn"
                  @click="onScheduleSend"
                  depressed
                  bottom
                  small
                  outlined
                  color="primary"
                  v-bind="attrs"
                >
                  Schedule Send
                </v-btn>
              </template>
              <!-- <v-date-picker
                v-model="scheduledDate"
                width="290"
                scrollable
                :show-current="false"
              >
                <v-spacer></v-spacer>
              </v-date-picker> -->
              <v-datetime-picker
                v-model="scheduledDate"
                :datetime="scheduledDate"
                @input="onSetScheduledDate"
                :text-field-props="dtpTextFieldProps"
                :date-picker-props="dtpDateProps"
                :time-picker-props="dtpTimeProps"
                time-format="HH:mm"
              ></v-datetime-picker>
            </v-dialog>
          </template>

          <v-btn
            class="message-send-btn mb-4"
            id="messageSubmitBtn"
            @click="onSubmitForm"
            depressed
            bottom
            small
            color="primary"
          >
            Send
          </v-btn>
        </div>
        <!-- </v-toolbar> -->
      </v-card>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";
import {
  REPLACE_WITH_REVIEW_LINK,
  REVIEW_REQUEST_DOMAIN
} from "../../../globalVars";
import VDatetimePicker from "../../calendar/DateTimePicker";

export default {
  name: "MessageEntryForm",
  components: {
    VDatetimePicker
  },
  props: {
    msg: String,
    messageScheduledId: Number,
    messageText: String,
    oldScheduledDate: Number
  },
  data: function() {
    return {
      REPLACE_WITH_REVIEW_LINK: REPLACE_WITH_REVIEW_LINK,
      REVIEW_REQUEST_DOMAIN: REVIEW_REQUEST_DOMAIN,
      scheduledDate: this.oldScheduledDate
        ? new Date(this.oldScheduledDate)
        : new Date(),
      messageValue: "",
      showDatePicker: false,
      dtpTextFieldProps: {
        appendIcon: "mdi-calendar"
      },
      dtpDateProps: {},
      dtpTimeProps: {
        ampmInTitle: true,
        allowedMinutes: [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55]
      }
    };
  },
  computed: {
    userId() {
      return this.$store.getters["entities/settings/query"]().first().userId;
    },
    user() {
      return this.$store.getters["entities/users/find"](this.userId);
    },
    account() {
      return this.$store.getters["entities/accounts"]().first();
    },
    currentCustomer() {
      return this.$store.getters["entities/customers/query"]().find(
        this.user.currentCustomerId
      );
    },
    inputPlaceholder() {
      return "Send a message to " + this.currentCustomer.longName;
    },
    messageTemplateListId() {
      let listType = this.$store.getters["entities/listTypes/query"]()
        .where(type => {
          return type.code == "msg_template";
        })
        .get();
      return listType.length > 0 ? listType[0].id : null;
    },
    messageTemplates() {
      let vueThis = this;
      let listItems = this.$store.getters["entities/listItems/query"]()
        .where(item => {
          return item.listTypeId == vueThis.messageTemplateListId;
        })
        .get();
      listItems =
        listItems.length > 0
          ? listItems.sort(
              (a, b) => (a.rank ? a.rank : 0) - (b.rank ? b.rank : 0)
            )
          : [];
      let templates = listItems.map(obj => {
        return {
          name: obj.name,
          value: obj.meta.value
        };
      });
      if (templates.length == 0) {
        templates.push({
          name: "Create your first template in settings",
          value: null
        });
      }
      return templates;
    }
  },
  created() {
    this.messageValue = this.messageText || "";
  },
  methods: {
    async onSelectTemplate(args) {
      let vueThis = this;
      if (args.templateText) {
        // TODO - allow many merge fields
        if (args.templateText.indexOf(vueThis.REPLACE_WITH_REVIEW_LINK) >= 0) {
          let response = await vueThis.$store.dispatch(
            "entities/redirectLink/getRedirectLink",
            {
              customerId: vueThis.currentCustomer.id
            }
          );
          vueThis.messageValue = args.templateText.replace(
            vueThis.REPLACE_WITH_REVIEW_LINK,
            response.url
          );
        } else {
          vueThis.messageValue = args.templateText;
        }
      }
    },
    onSetScheduledDate(evt) {
      const scheduledDate = new Date(evt);
      if (scheduledDate < new Date()) {
        alert("You should only schedule a message in the future.");
      } else {
        if (
          confirm(
            "Send text automatically at " +
              this.formattedDateTime(scheduledDate) +
              "?"
          )
        ) {
          const mergeFieldRegex = /\{\{(([A-Z])+(_?)([A-Z])+)+\}\}/g;
          const newMessageValue = this.messageValue;
          if (newMessageValue == "") {
            alert("You can't send an empty text.");
            return;
          } else if (newMessageValue.match(mergeFieldRegex)) {
            alert(
              "You still have merge fields that did not fill in values. You'll have to update them manually."
            );
            return;
          } else if (newMessageValue.indexOf(this.REVIEW_REQUEST_DOMAIN) >= 0) {
            this.isReviewRequest = true;
          }

          if (this.messageScheduledId > 0) {
            this.$store.dispatch("entities/customers/update", {
              where: this.currentCustomer.id,
              data: {
                viewedAt: Date.now(),
                messagesScheduled: [
                  {
                    id: this.messageScheduledId,
                    isDirty: true,
                    messageData: JSON.stringify({
                      message: newMessageValue
                    }),
                    isSent: false,
                    scheduledAt: scheduledDate,
                    userId: this.user.id,
                    updatedAt: Date.now()
                  }
                ]
              },
              update: ["messagesScheduled"]
            });
            this.$store.dispatch(
              "entities/messagesScheduled/updateMessageScheduled",
              {
                accountId: this.user.accountId,
                customerId: this.currentCustomer.id,
                id: this.messageScheduledId,
                isDirty: true,
                messageData: JSON.stringify({
                  message: newMessageValue
                }),
                isSent: false,
                scheduledAt: scheduledDate,
                userId: this.user.id,
                updatedAt: Date.now()
              }
            );
          } else {
            const tempId = this.$uuidv4();
            this.$store.dispatch("entities/customers/update", {
              where: this.currentCustomer.id,
              data: {
                viewedAt: Date.now(),
                messagesScheduled: [
                  {
                    id: tempId,
                    isDirty: true,
                    messageData: JSON.stringify({
                      message: newMessageValue
                    }),
                    isSent: false,
                    scheduledAt: scheduledDate,
                    userId: this.user.id,
                    updatedAt: Date.now()
                  }
                ]
              },
              insert: ["messagesScheduled"]
            });
            this.$store.dispatch(
              "entities/messagesScheduled/createMessageScheduled",
              {
                accountId: this.user.accountId,
                customerId: this.currentCustomer.id,
                id: tempId,
                tempId: tempId,
                isDirty: true,
                messageData: JSON.stringify({
                  message: newMessageValue
                }),
                isSent: false,
                scheduledAt: scheduledDate,
                userId: this.user.id,
                updatedAt: Date.now()
              }
            );
          }
          this.onCancel();
        }
      }
    },
    onScheduleSend(evt) {
      const newMessageValue = this.messageValue;
      if (newMessageValue == "") {
        alert("You can't send an empty text.");
        return;
      }
      evt.preventDefault();
      // alert("need calendar");
      this.showDatePicker = true;
    },
    onSubmitForm(evt) {
      evt.preventDefault();
      const mergeFieldRegex = /\{\{(([A-Z])+(_?)([A-Z])+)+\}\}/g;
      const newMessageValue = this.messageValue;
      if (newMessageValue == "") {
        alert("You can't send an empty text.");
        return;
      } else if (newMessageValue.match(mergeFieldRegex)) {
        alert(
          "You still have merge fields that did not fill in values. You'll have to update them manually."
        );
        return;
      } else if (newMessageValue.indexOf(this.REVIEW_REQUEST_DOMAIN) >= 0) {
        this.isReviewRequest = true;
      }
      const tempId = this.$uuidv4();
      this.$store.dispatch("entities/customers/update", {
        where: this.currentCustomer.id,
        data: {
          viewedAt: Date.now(),
          messages: [
            {
              id: tempId,
              isDirty: true,
              messageBody: newMessageValue,
              isInbound: false,
              isReviewRequest: this.isReviewRequest,
              userId: this.user.id,
              updatedAt: Date.now()
            }
          ]
        },
        insert: ["messages"]
      });
      this.$store.dispatch("entities/messages/createMessage", {
        accountId: this.user.accountId,
        customerId: this.currentCustomer.id,
        id: tempId,
        tempId: tempId,
        isDirty: true,
        messageType: "sms",
        messageBody: newMessageValue,
        isInbound: false,
        isRead: true,
        isReviewRequest: this.isReviewRequest,
        userId: this.user.id,
        updatedAt: Date.now()
      });

      this.onCancel();
    },
    onCancel() {
      this.$parent.hideEntryForms();
    },
    onDelete() {
      if (confirm("Are you sure want to delete this scheduled message?")) {
        this.$store.dispatch(
          "entities/messagesScheduled/deleteMessageScheduled",
          {
            accountId: this.user.accountId,
            id: this.messageScheduledId,
            isDirty: true
          }
        );
        this.onCancel();
      }
    },
    formattedDateTime(number) {
      return format(new Date(number), "E h:mm a, M/d/y");
    }
  }
};
</script>

<style scoped lang="stylus"></style>
